import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=463f57f6&scoped=true"
var script = {}
import style0 from "./bottom.vue?vue&type=style&index=0&id=463f57f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463f57f6",
  null
  
)

export default component.exports